import { CashFieldSet } from '@/App/Blotter/grids/cash/details/CashFieldSet.tsx';
import { SwapFieldSet } from '@/App/Blotter/grids/cash/details/SwapFieldSet.tsx';
import {
  type BlotterProductType,
  cashTradeTypes,
  swapTradeTypes,
} from '@/store/blotter/api/types/BlotterTradeEntry.ts';
import type { BlotterCashEntry } from '@/store/blotter/types/BlotterCashEntry.ts';

type Props = {
  entry: BlotterCashEntry;
};

export const Fieldset = ({ entry }: Props) => {
  if ((cashTradeTypes as unknown as BlotterProductType).includes(entry.product)) {
    return <CashFieldSet entry={entry} />;
  }
  if ((swapTradeTypes as unknown as BlotterProductType).includes(entry.product)) {
    return <SwapFieldSet entry={entry} />;
  }
  return <div>Unknown product type {entry.product}</div>;
};
